import { render, staticRenderFns } from "./MenuItemText.vue?vue&type=template&id=18d39683"
import script from "./MenuItemText.vue?vue&type=script&lang=js"
export * from "./MenuItemText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports